$(function (){
    $('.add-to-cart-button').click(function(){
        $('.add-to-cart-modal').removeClass('open');
        $(this).siblings('.add-to-cart-modal').addClass('open');
    })

    $('.add-to-cart-modal .close, .add-to-cart-modal .close').click(function () {
        $('.add-to-cart-modal').removeClass('open');
    })
})